import { makeStyles, css } from '@conexasaude/hero'

const useStyles = makeStyles({
  confirmProfessionalSection: ({ colors }) => css`
    .professional-avatar {
      display: flex;
      align-items: center;
      margin-top: 26px;
      padding-bottom: 32px;
      margin-bottom: 32px;
      border-bottom: 1px solid #d1d3d7;

      h5 {
        font-size: 20px;
        font-weight: bold;
        line-height: 32px;
        color: ${colors.neutral[900]};
      }
      span {
        color: ${colors.neutral[500]};
        font-size: 16px;
        line-height: 24px;
      }
    }
  `,
  avatar: () => css`
    width: 80px;
    height: 80px;
    margin-right: 16px;
  `,
})

export default useStyles
